export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pins.vue?vue&type=template&id=e05d7132"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/pins.vue?vue&type=template&id=e05d7132
// module id = sz25
// module chunks = 0